export const publicImgs = [
    "/img/logo.JPEG",
];